import React, { useState, useEffect } from 'react';
import { useEditor, ROOT_NODE } from '@craftjs/core';
//import { FaChevronUp, FaChevronDown, FaEye, FaEyeSlash } from 'react-icons/fa'
import {
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  Preview,
  PreviewMode,
} from '../../../../pb-components/icons';
import { isDisabled, isDeletable } from '../../../../utils/node';

const TreeNode = ({ id, level, open: defaultOpen }) => {
  const { selected, query, actions, nodes, connectors } = useEditor(
    (state) => ({
      selected: state.events.selected,
      nodes: state.nodes,
    })
  );

  const [open, setOpen] = useState(defaultOpen);
  const [nodeDetail, setNodeDetail] = useState();

  useEffect(() => {
    if (id && !isDisabled(id, query)) {
      setNodeDetail(query.node(id).get());
    }
  }, [id, nodes]);

  const onSelectNode = () => {
    actions.selectNode(id);
    document
      .getElementsByClassName(id)[0]
      .scrollIntoView({ behaviour: 'smooth' });
  };

  const onOpenTree = (event) => {
    event.stopPropagation();
    setOpen(!open);
  };

  const onHide = () => {
    const hidden = nodeDetail.data.hidden;
    actions.history.ignore().setHidden(id, !hidden);
  };

  return (
    <>
      {nodeDetail && (
        <div
          className="tree-node-container"
          ref={(ref) => connectors.hover(ref, id)}
          onDoubleClick={(e) => onOpenTree(e)}
        >
          <div
            className={`tree-node-header ${
              selected === id ? 'tree-node-header__active' : ''
            }`}
          >
            <div onClick={() => onSelectNode()}>
              {[...Array(level)].map((e, i) => (
                <span key={i}>--</span>
              ))}
              <span> </span>
              <span>
                {nodeDetail.data.displayName}{' '}
                {nodeDetail.data.nodes.length !== 0 &&
                  `(${nodeDetail.data.nodes.length})`}
              </span>
            </div>
            <div className="tree-node-header-end">
              {isDeletable(id, query) && (
                <div onClick={() => onHide()}>
                  {nodeDetail.data.hidden ? <Preview /> : <PreviewMode />}
                </div>
              )}
              {nodeDetail.data.nodes.length !== 0 && (
                <div onClick={(e) => onOpenTree(e)}>
                  {open ? <ChevronUp /> : <ChevronDown />}
                </div>
              )}
            </div>
          </div>
          {open &&
            nodeDetail.data.nodes.map((nodeId) => {
              return (
                <TreeNode
                  id={nodeId}
                  key={nodeId}
                  level={level + 1}
                  open={defaultOpen}
                />
              );
            })}
        </div>
      )}
    </>
  );
};

export const Layers = ({ open }) => {
  const { selected, nodes, query, actions } = useEditor((state) => ({
    selected: state.events.selected,
    nodes: state.nodes,
  }));

  return (
    <>
      <TreeNode id={ROOT_NODE} level={0} open={open} />
    </>
  );
};
